import { FormControlLabel, Switch, Typography, Box } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";
import { styled } from "@mui/material/styles";
import { postData } from "../Services/postData";
import { endpoints } from "../Utils/UrlEnum";
import { AlertsTypes } from "../Utils/Constants";
import { deleteData } from "../Services/deleteData";

export default function ActivateNotifications({
  notification,
  setNotification,
}: {
  notification: any;
  setNotification: (notification: any) => void;
}) {
  const NotificationSwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 38,
    padding: 8,
    "& .MuiSwitch-switchBase": {
      padding: 7,
      "&.Mui-checked": {
        transform: "translateX(24px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.primary.main,
          opacity: 0.8,
        },
      },
    },
    "& .MuiSwitch-thumb": {
      width: 24,
      height: 24,
      backgroundColor: "#fff",
      boxShadow: theme.shadows[2],
    },
    "& .MuiSwitch-track": {
      borderRadius: 20,
      backgroundColor: theme.palette.grey[400],
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 300,
      }),
    },
  }));
  const clientId = localStorage.getItem("clientId");

  /**
   * Submits a change request for notification settings.
   * If the notification has an ID, it deletes the existing notification.
   * Otherwise, it posts a new notification with the specified parameters.
   */

  const submitChange = async () => {
    const body = {
      name: AlertsTypes.LIVE_LEGISLATION,
      clientId,
      sendEmail: true,
    };

    notification?._id
      ? await deleteData(`${endpoints.alert.main}/${notification._id}`).then(
        (response) => {
          if (response && response.data) {
            setNotification(null);
          }
        }
      )
      : await postData(endpoints.alert.main, body).then((response) => {
        if (response && response.data) {
          setNotification(response?.data?.newAlert);
        }
      });
  };

  /**
   * Renders the switch component for notification activation.
   */
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        p: 2,
      }}
    >
      <FormControlLabel
        control={
          <NotificationSwitch
            checked={notification?._id ? true : false}
            onChange={(e) => {
              submitChange();
            }}
            color="primary"
          />
        }
        label={
          <Typography
            variant="h6"
            fontWeight={600}
            color="primary.dark"
            sx={{ ml: 1 }}
          >
            {Vocabulary.activateNotifications}
          </Typography>
        }
        sx={{ m: 0 }}
      />
    </Box>
  );
}
